export const  UPDATE_MESSAGES = 'UPDATE_MESSAGES';
export const  SET_SELECTED_MESSAGE = 'SET_SELECTED_MESSAGE';
export const  UPDATE_SELECTED_MESSAGE_RESPONSES = 'UPDATE_SELECTED_MESSAGE_RESPONSES';